import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { isString } from '@util/data/is-exist';

import Empty from './assets/empty.svg?react';
import { Wrapper } from './empty-data.style';

interface EmptyDataProps {
  title?: string;
}

export const EmptyData = ({ title }: EmptyDataProps) => (
  <Wrapper>
    <Empty />
    {isString(title) && (
      <Text color={ColorEnum.Black150} level='m'>
        {title}
      </Text>
    )}
  </Wrapper>
);
